import React from 'react';
import { motion } from 'framer-motion';

const cases = [
  {
    title: "Global Tech Consolidation",
    challenge: "Fragmented market share across European and Asian territories.",
    solution: "Strategic buy-side acquisition of 3 regional competitors.",
    outcome: "Market share increased by 40% with unified global operations."
  },
  {
    title: "Industrial Divestiture",
    challenge: "Non-core asset dragging down enterprise valuation.",
    solution: "Structured sell-side carve-out and private equity positioning.",
    outcome: "Successful $120M divestiture at 12x EBITDA multiple."
  },
  {
    title: "Strategic Retail Merger",
    challenge: "Declining brick-and-mortar footprint facing digital disruption.",
    solution: "Horizontal merger with e-commerce logistics leader.",
    outcome: "200% growth in digital sales within 18 months post-merger."
  }
];

const MACases = () => {
  return (
    <section className="py-24 bg-brand-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-bold tracking-tight text-brand-black mb-4">Strategic Transaction Profiles</h2>
          <p className="text-brand-gold tracking-widest uppercase text-xs font-bold">Executive Case Reports</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-10">
          {cases.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-brand-gray border border-brand-border p-10 hover:shadow-2xl transition-all duration-500"
            >
              <h3 className="text-xl font-bold text-brand-black mb-8 flex items-center gap-4">
                <span className="w-4 h-[1px] bg-brand-gold"></span>
                {item.title}
              </h3>
              
              <div className="space-y-6">
                <div>
                  <label className="text-[10px] font-bold uppercase tracking-widest text-brand-gold block mb-1">Challenge</label>
                  <p className="text-sm text-brand-muted leading-relaxed">{item.challenge}</p>
                </div>
                <div>
                  <label className="text-[10px] font-bold uppercase tracking-widest text-brand-gold block mb-1">Solution</label>
                  <p className="text-sm text-brand-muted leading-relaxed">{item.solution}</p>
                </div>
                <div className="pt-6 border-t border-brand-border">
                  <label className="text-[10px] font-bold uppercase tracking-widest text-brand-black block mb-1">Outcome</label>
                  <p className="text-brand-black font-bold text-lg">{item.outcome}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MACases;